import React, { FC } from "react";
import translit from "translit-passport";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { useHistory, useRouteMatch } from "react-router-dom";

import ViolationRecordingForm from "~/components/Forms/ViolationRecordingForm";
import Preloader from "~/components/Preloader";
import Wrapper from "~/shared/ui/Wrapper";
import { useGetLocationData, useSetLocationData } from "~/hooks/locationData";
import { getFormatDate } from "~/libs/getFormatDate";
import { useGetViolationByIdQuery } from "~/schemas/generated/graphql";

interface IProps {}

const ViolationRecording: FC<IProps> = () => {
  const { t } = useTranslation();
  const isEn = localStorage.getItem("language") === "en";
  const { page } = useGetLocationData();
  const { params } = useRouteMatch();
  const personalId = params["id"];
  const isAdd = personalId === "new";
  const setData = useSetLocationData();
  const history = useHistory();

  const goBack = () => {
    history.push(
      isAdd ? "/violations" : `/violations/description/${personalId}`
    );
    page && setData("page", page);
  };

  let violationInstance = {
    dateFrom: new Date(),
  };

  const { data, loading } = useGetViolationByIdQuery({
    variables: {
      id: personalId,
    },
    fetchPolicy: "no-cache",
    skip: isAdd,
  });

  const violationInstanceByServer = get(
    data,
    "ViolationGetter.getById",
    undefined
  );

  if (!!violationInstanceByServer) {
    const {
      ViolationType,
      reportedByUser,
      status,
      createdAt,
      fixDeadline,
      DocId,
    } = violationInstanceByServer;
    violationInstance = {
      ...{
        ...violationInstanceByServer,
        id: personalId,
        violationType: {
          value: ViolationType.id,
          label: isEn
            ? translit.cyrillicToLatin(ViolationType.name)
            : ViolationType.name,
        },
        user: isEn ? reportedByUser.fullnameEn : reportedByUser.fullname,
        file: DocId,
        status: { value: 1, label: t(`violationsTable.${status}`) },
        dateFrom: getFormatDate(createdAt, true),
        dateTo: new Date(fixDeadline),
      },
    };
  }

  return (
    <Wrapper.Content
      title={t("violation.title")}
      goBackHandler={goBack}
      txtBtn={t("ui.back")}
    >
      {loading ? (
        <Preloader />
      ) : (
        <ViolationRecordingForm
          {...{
            personalId,
            violationInstance,
          }}
        />
      )}
    </Wrapper.Content>
  );
};

export default ViolationRecording;
